<template>
    <div class="mx-auto col-md-8 col-sm-12 header-margin pt-4">
        <div class="text-left text-md-center">
            <h3>購入代金の送付が完了いたしました。</h3>
            <p class="mt-2 text-center">
                商品がお手元に届くまで5営業日ほど頂いております。<br />また状況に応じてお届けまでにかかる日数が前後する場合がございます。
            </p>
        </div>

        <div class="text-left mt-4 border-0 card card-pricing">
            <div class="card-head">
                <h4>{{ $t('hec.payments.balance') }}</h4>
            </div>
            <div class="card-body card-success">
                <p class="card-text text-center">
                    <span v-if="detail.balances.hec">{{ detail.balances.hec | floor }} HEC</span>
                    <span v-else>HEC</span>
                </p>
            </div>
        </div>

        <div class="form-row py-3 justify-content-center">
            <div class="col-md-3">
                <router-link :to="{ name: 'home' }" class="btn btn-primary btn-block">
                    {{ $t('hec.successModule.closeBtn') }}
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import tokenService from "../../services/TokenService";
    
    export default {
        name: 'OrderSuccess',

        components: {},

        mounted() {
            this.sessionOrderClear();
        },

        data() {
            return {
                detail: {
                    balances: {
                        hec: 0
                    }
                }
            }
        },

        created() {
            this.fetchData();
        },

        methods: {
            async fetchData() {
                this.detail = (await tokenService.getWallet()).data;
            },

            sessionOrderClear() {
                sessionStorage.removeItem('amount');
                sessionStorage.removeItem('copy');
                sessionStorage.removeItem('length');
                sessionStorage.removeItem('order_address_1');
                sessionStorage.removeItem('order_address_2');
                sessionStorage.removeItem('order_company_name');
                sessionStorage.removeItem('order_forwarding_address_1');
                sessionStorage.removeItem('order_forwarding_address_2');
                sessionStorage.removeItem('order_forwarding_company_name');
                sessionStorage.removeItem('order_forwarding_name');
                sessionStorage.removeItem('order_forwarding_phone_number');
                sessionStorage.removeItem('order_forwarding_post_number_1');
                sessionStorage.removeItem('order_forwarding_post_number_2');
                sessionStorage.removeItem('order_name');
                sessionStorage.removeItem('order_phone_number');
                sessionStorage.removeItem('order_post_number_1');
                sessionStorage.removeItem('order_post_number_2');
                sessionStorage.removeItem('price');
                sessionStorage.removeItem('privacy_policy');
                sessionStorage.removeItem('tax');
                sessionStorage.removeItem('total');
            },
        }
    }
</script>

<style>
    @import "~vodal/common.css";
    @import "~vodal/slide-down.css";

    .card-success {
        background: #c2ffc2 !important;
    }
</style>
